import * as React from 'react'
import LeaveSiteWarning from '~/components/shared/LeaveSiteWarning/index'
import { Button } from '~/lib/ui/button'

export function NameCell({ row }) {
  const { name, url } = row.original

  return (
    <div className="flex flex-col gap-1 pr-2">
      <LeaveSiteWarning url={url}>
        <Button variant="link" className="justify-start">
          <div className="text-normal line-clamp-1 font-bold">{name}</div>
        </Button>
      </LeaveSiteWarning>
    </div>
  )
}
